import { combineReducers } from "redux";
import AuthReducer from "./AuthReducer";
import SettingReducer from "./SettingReducer";

const reducers = combineReducers({
  auth: AuthReducer,
  setting: SettingReducer
});

export default reducers;